import LazyLayout from "./LazyLayout";

export default LazyLayout;
